<template>
  <router-view />
  <p-toast />
</template>
<script lang="ts" setup></script>
